import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 10000,
    color: "#fff"
  }
}));

const LoadingSpinnerWithBackdrop = ({ size }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="primary" size={size} />
    </Backdrop>
  );
};

export default LoadingSpinnerWithBackdrop;

LoadingSpinnerWithBackdrop.defaultProps = {
  size: 80
};
